import React from 'react';
import { openAddInputFormsForQuestions } from '../../../adminSlice';
import './AdminTableQuestions.scss';
import TableQuestions from './TableQuestions/TableQuestions';


export default class AdminTableQuestions extends React.Component {
    constructor(props) {
        super(props);

        this.onAdd = this.onAdd.bind(this);
    }

    onAdd() {
        const { dispatch } = this.props;
    
        dispatch(openAddInputFormsForQuestions());
    
    }
    render() {
        let style;
       // console.log(this.props.adminState.dataSubCategoryId.length);
        if (this.props.adminState.selectedQuize) {
          
                style = ''
            } else {
                style = 'disabled'
            }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableQuestions">
                   <p className='tableName'>Список вопросов {this.props.adminState.selectedQuize} теста</p>

                   <TableQuestions 
                   dispatch={dispatch}
                   data={this.props.adminState.dataQuestionsId}
                   />

                    <button className='addButton' onClick={this.onAdd} disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button>



                
            </div>
        )
    }
}